<template>
	<div class="comments">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default{
	name: 'PostComment'
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/Post/PostComment.vue